/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
'use strict';

var EditorState = require("./EditorState");

var DraftModifier = require("./DraftModifier");
/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */


function editOnCompositionStart(editor, e) {
  var editorState = editor._latestEditorState;
  if (editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();

    if (!selection.isCollapsed()) {
      // Remove range before entering composition mode
      var removedContent = DraftModifier.removeRange(
        contentState,
        selection,
        'forward',
      );
      var undoStack = editorState.getUndoStack();
      editor.update(
        EditorState.set(editorState, {
          currentContent: removedContent,
          lastChangeType: 'remove-range',
          undoStack: undoStack.push(contentState),
        }),
      );
    }
  }

  editor.setMode('composite');
  editor.update(EditorState.set(editor._latestEditorState, {
    inCompositionMode: true,
    // Sirius fix, unable to quit composition mode,
    // then allow native rendering, no re-render is necessary for this `EditorState`
    nativelyRenderedContent: editor._latestEditorState.getCurrentContent()
  }));
  // Allow composition handler to interpret the compositionstart event
  editor._onCompositionStart(e);
}

module.exports = editOnCompositionStart;